import { render, staticRenderFns } from "./CsAsignacionesTipoVehiculo.vue?vue&type=template&id=edd27fee"
import script from "./CsAsignacionesTipoVehiculo.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesTipoVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports